import React from "react";
import Source1 from "assets/images/H-icon.svg";
import Source2 from "assets/images/ch-icon.svg";
import Source3 from "assets/images/ft-icon.svg";
import Source4 from "assets/images/rocket.svg";
import ArrowUp from "assets/images/arrow_up.svg";
import Facebook from "assets/images/facebook.svg";
import instagram from "assets/images/instagram.svg";
import Twitter from "assets/images/twitter.svg";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { timeAgo } from "utils/timeAgo";

const SHOW_SOCIAL_BLOCK = false;

const HotNewsCard = ({ title, summary, linkCount, _id, source_logos, growth_pct }) => {
    const navigate = useNavigate();
    const { t } = useTranslation();
    const handleClick = () => {
        navigate(`/news/news-view/${_id}`);
    }
    return (
        <div className="news_comment_card rounded shadow-sm" onClick={handleClick} style={{ cursor: "pointer" }}>
            <h6 className=" fw-semibold comment_title">{title || t("news.untitled")}</h6>
            <p className="text-white fw-light comment_description">
                {summary || ""}
            </p>

            {/* Highlight Area */}
            <div className="hot_news_detail d-flex justify-content-between align-items-center mt-3  ">

                {/* Left - News Sources */}
                <div className="news_sourace_block d-flex align-items-center gap-2">
                    <div className="source-avatars d-flex">
                        {source_logos && source_logos.slice(0, 4).map((logo, index) => (
                            <img key={index} src={logo} alt={t("news.source.logoAlt", { index: index + 1 })} className="source-icon" />
                        ))}
                    </div>
                                          {linkCount - 4 > 0 && (
  <span className="text-light small">+{linkCount - 4}</span>
)}
                </div>

                {/* Middle - Social Media */}
                {SHOW_SOCIAL_BLOCK && (
                  <div className="news_socialMedia_block d-flex align-items-center gap-2">
                      <div>
                          <img src={instagram} alt="" className="social-icon"/>
                          <img src={Twitter} alt="" className="social-icon" />
                          <img src={Facebook} alt="" className="social-icon" />

                      </div>
                      <span className="text-light small">43K</span>
                  </div>
                )}

                {/* Right - Percentage Growth */}
                <div className="d-flex align-items-center gap-2 px-2 py-1 rounded growth-box">
                    <span className="text-light small">{growth_pct}%</span>
                    <span>
                        <img src={ArrowUp} alt="" />
                    </span>
                </div>
            </div>
        </div>
    );
};

export default HotNewsCard;
